import { getKeyLabel } from '@snowit/hooks/useHotkeys';
import { Flex, Typo } from '@snowit/ui';

import s from './KeyboardShortcut.module.scss';

export interface IKeyboardShortcut {
  shortcut: string;
}

const KeyboardShortcut = (props: IKeyboardShortcut) => {
  const { shortcut } = props;
  const keys = getKeyLabel(shortcut);

  return (
    <Flex className={s.wrapper} gap={[0.125]}>
      {keys.map((item) => (
        <Typo key={item} className={s.kbd} text={item} tag={'kbd'} size={'sm'} />
      ))}
    </Flex>
  );
};

export default KeyboardShortcut;
